<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-add-subscription`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 3.996V8H10v32l14-8.669 14 8.617L37.999 22h4L42 43.983a2 2 0 01-3.04 1.709l-13.92-8.474a2 2 0 00-2.08 0L9.04 45.691A2 2 0 016 43.983V5.996a2 2 0 012-2h16zM36.718 2c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77V8h4.718c.446 0 .607.046.77.134.163.087.291.215.378.378.088.163.134.324.134.77v1.436c0 .446-.046.607-.134.77a.908.908 0 01-.378.378c-.163.088-.324.134-.77.134H38L38 16.718c0 .446-.046.608-.134.77a.908.908 0 01-.378.378c-.163.088-.324.134-.77.134h-1.436c-.446 0-.607-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.162-.134-.324-.134-.77L33.999 12 29.282 12c-.446 0-.608-.046-.77-.134a.908.908 0 01-.378-.378c-.088-.162-.134-.324-.134-.77V9.282c0-.446.046-.607.134-.77a.908.908 0 01.378-.378c.162-.088.324-.134.77-.134L34 7.999V3.282c0-.446.046-.607.134-.77a.908.908 0 01.378-.378c.163-.088.324-.134.77-.134h1.436z"/></svg>
</template>
<script>

export default {
  name: 'IconAddSubscription',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
